var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7651 22.2197C21.999 22.2197 24.1828 21.5681 26.0402 20.3474C27.8977 19.1266 29.3453 17.3915 30.2002 15.3614C31.0551 13.3314 31.2788 11.0975 30.843 8.94244C30.4072 6.78734 29.3314 4.80774 27.7518 3.254C26.1722 1.70026 24.1596 0.642151 21.9686 0.213474C19.7776 -0.215202 17.5066 0.00482297 15.4427 0.845701C13.3789 1.68658 11.6149 3.11055 10.3738 4.93756C9.13265 6.76457 8.47022 8.91254 8.47022 11.1099V11.112C8.47022 14.0579 9.65999 16.8832 11.7778 18.9663C13.8956 21.0494 16.7679 22.2197 19.763 22.2197H19.7651ZM27.6711 24.9961H26.1967C24.1798 25.9111 21.9851 26.385 19.764 26.385C17.5429 26.385 15.3482 25.9111 13.3313 24.9961H11.859C8.71356 24.9967 5.69719 26.2261 3.47326 28.414C1.24934 30.6019 -1.39442e-05 33.5691 1.16756e-10 36.6629V40.2716C0.000555364 41.3762 0.446916 42.4355 1.24101 43.2166C2.03511 43.9977 3.11198 44.4367 4.23501 44.4373H35.2949C36.4179 44.4367 37.4947 43.9977 38.2888 43.2166C39.0829 42.4355 39.5293 41.3763 39.5299 40.2716V36.6629C39.5294 33.5694 38.2797 30.6028 36.0559 28.4153C33.832 26.2279 30.8159 24.9988 27.6709 24.9982L27.6711 24.9961Z",
    fill: "#BAC0CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeProfileIcon);
export default __webpack_public_path__ + "static/media/home-profile-icon.3bfca6c29b87085b3f3a0775144c41f4.svg";
export { ForwardRef as ReactComponent };